import React from 'react'
import AppBar from './AppBar'

export default function Page({ children, className = 'px-4 py-3 ' }) {
  return (
    <div className={className + ' h-screen overflow-y-auto'}>
      <AppBar />
      <br></br>
      {children}
    </div>
  )
}
